import React from 'react';

interface SMSPageLayoutProps {
  title: string;
  children?: React.ReactNode;
}

export const SMSPageLayout: React.FC<SMSPageLayoutProps> = ({ title, children }) => {
  return (
    <div>
      {/* Top Banner */}
      <div className="bg-white border-b">
        <div className="px-6 py-4 flex items-center justify-between">
          <h1 className="text-xl font-bold">{title}</h1>
        </div>
      </div>

      {/* Main Content */}
      <div className="p-6">
        <div className="mx-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

export {}; 